export const sortNumbers = (values) =>
  Array.isArray(values) ? values.map((i) => Number(i)).sort((a, b) => a - b) : values;

export const unique = (data) => {
  const flatArr = data.flatMap((value) => value);
  return [...new Set(flatArr)];
};

function compareKeys(key1, key2) {
  const entries = Object.entries(key1);
  for (let i = 0; i < entries.length; i++) {
    if (key2[entries[i][0]] !== entries[i][1]) {
      return false;
    }
  }
  return true;
}

function createKey(obj, ...fields) {
  const key = {};
  for (let i = 0; i < fields.length; i++) {
    key[fields[i]] = obj[fields[i]];
  }
  return key;
}

export function groupByFields(arr, ...fields) {
  const groups = [];
  for (let i = 0; i < arr.length; i++) {
    const key = createKey(arr[i], ...fields);
    const group = groups.find((g) => compareKeys(g.key, key));
    if (group) {
      group.data.push(arr[i]);
    } else {
      groups.push({
        key,
        data: [arr[i]],
      });
    }
  }
  return groups;
}

export function groupBy(arr = [], groupFn, initialObj = {}) {
  const initialObjVar = initialObj;

  for (let i = 0; i < arr.length; i++) {
    const groupName = groupFn(arr[i]);
    if (initialObjVar[groupName] !== undefined) {
      initialObjVar[groupName].push(arr[i]);
    } else {
      initialObjVar[groupName] = [arr[i]];
    }
  }
  return initialObjVar;
}
